import { createSelector, createSlice } from '@reduxjs/toolkit';
import qs from 'qs';
import * as R from 'ramda';
import http from 'utils/http';
import { createSnack } from 'snackbar/snackbarSlice';

const initialState = {
  error: '',
  fetchPending: false,
  originatorLocationProductReidVaporPressuresList: [],
};

const reducers = {
  fetchOriginatorLocationProductReidVaporPressuresError(state, { payload }) {
    return R.assoc('error', payload.error, state);
  },
  fetchOriginatorLocationProductReidVaporPressuresPending(state, { payload }) {
    return R.assoc('fetchPending', payload, state);
  },
  fetchOriginatorLocationProductReidVaporPressuresSuccess(state, { payload }) {
    return R.assoc('originatorLocationProductReidVaporPressuresList', payload, state);
  },
  resetOriginatorLocationProductReidVaporPressures() {
    return initialState;
  },
};

const { actions, reducer } = createSlice({
  initialState,
  name: 'originatorLocationProductReidVaporPressures',
  reducers,
});

// Selectors
export const getOriginatorLocationProductReidVaporPressures = state =>
  state.pto.originatorLocationProductReidVaporPressures
    .originatorLocationProductReidVaporPressuresList;

export const getOriginatorLocationRvpOptions = createSelector(
  getOriginatorLocationProductReidVaporPressures,
  locationRvps => [
    { label: 'Any', value: null },
    ...locationRvps.map(rvpEntry => ({
      label: rvpEntry.toString(),
      value: rvpEntry,
    })),
  ]
);

export const {
  fetchOriginatorLocationProductReidVaporPressuresPending,
  fetchOriginatorLocationProductReidVaporPressuresSuccess,
  fetchOriginatorLocationProductReidVaporPressuresError,
  resetOriginatorLocationProductReidVaporPressures,
} = actions;

// Actions
let fetchController;
export const fetchOriginatorLocationProductReidVaporPressures = params => async dispatch => {
  const formattedParams = qs.stringify(params, {
    allowDots: true,
    encode: false,
  });
  dispatch(fetchOriginatorLocationProductReidVaporPressuresPending(true));
  if (fetchController) fetchController.abort();
  fetchController = new AbortController();
  const { signal } = fetchController;
  return http
    .get(
      `/product-transfer-orders/get-unique-originator-location-product-reid-vapor-pressures?${formattedParams}`,
      { signal }
    )
    .then(({ data }) => {
      dispatch(
        fetchOriginatorLocationProductReidVaporPressuresError({
          error: '',
        })
      );
      dispatch(fetchOriginatorLocationProductReidVaporPressuresSuccess(data));
    })
    .catch(error => {
      if (error?.response?.data?.title) {
        dispatch(
          createSnack({
            message: error.response.data.title,
            options: { variant: 'error' },
          })
        );
        dispatch(
          fetchOriginatorLocationProductReidVaporPressuresError({
            error: error.response.data.title,
          })
        );
      }
    })
    .finally(() => dispatch(fetchOriginatorLocationProductReidVaporPressuresPending(false)));
};

export default reducer;
